import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { shouldSuppressRoleRedirect } from '../../features/walkthrough/walkthroughOrchestrator';
import {
  canAccessMySkillMatrix,
  getDefaultDashboardPath,
  isMySkillMatrixRouteRoles,
  resolvePrimaryRole,
  routeAllowsRole,
} from '../../utils/rolePriority';
import { isAuthRedirectInProgress } from '../../utils/authRedirect';
import ProtectedRoute from './ProtectedRoute';

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  return (
    <ProtectedRoute>
      <RoleChecker allowedRoles={allowedRoles}>{children}</RoleChecker>
    </ProtectedRoute>
  );
};

const RoleChecker = ({ children, allowedRoles }) => {
  const { user, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!user) {
    if (isAuthRedirectInProgress()) {
      return null;
    }
    return <Navigate to="/" replace />;
  }

  const hasAccess = isMySkillMatrixRouteRoles(allowedRoles)
    ? canAccessMySkillMatrix(user)
    : routeAllowsRole(allowedRoles, user);

  if (!hasAccess) {
    if (shouldSuppressRoleRedirect(location.pathname)) {
      return children;
    }

    const primary = resolvePrimaryRole(user);
    return <Navigate to={getDefaultDashboardPath(primary)} replace />;
  }

  return children;
};

export default RoleProtectedRoute;
